// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Qvxf","name":"ConsentHeader_name__23lDr","birthday":"ConsentHeader_birthday__3hP51","skeleton":"ConsentHeader_skeleton__2iKWw"};